var map = {
	"./am.json": "8f9d",
	"./ar.json": "af08",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./pt.json": "5d67",
	"./sw.json": "0e32",
	"./th.json": "8680"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";